import { useQuery } from "@tanstack/react-query";
import { BRIEF_INVOICE_AGGREGATION_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefInvoiceAggregation(briefId: string) {
  const { data, isFetching } = useQuery({
    queryKey: [...BRIEF_INVOICE_AGGREGATION_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefInvoicesAggregation(briefId),
  });

  return {
    aggregation: data?.data,
    isFetching,
  };
}
